import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/backgrounds/Silk/Silk.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/FadeIn.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["GridPattern"] */ "/vercel/path0/apps/lander/src/components/GridPattern.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShinyButton"] */ "/vercel/path0/apps/lander/src/components/magicui/shiny-button.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/laptop.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/meeting.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/whiteboard.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/vercel/path0/node_modules/.pnpm/@iconify+react@5.2.1_react@19.2.7/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.10_@babel+core@7.27.1_@opentelemetry+api@1.9.0_@playwright+test@1.54.1_react-_8dcd915e972dc0355f470e2078e8ebb8/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.10_@babel+core@7.27.1_@opentelemetry+api@1.9.0_@playwright+test@1.54.1_react-_8dcd915e972dc0355f470e2078e8ebb8/node_modules/next/dist/client/image-component.js");
